/**
 * Whether the account is granted no page at all.
 *
 * An account signed in with no project of its own and no permission holds
 * nothing the interface builder answers: the components and the sidebar items
 * are refused every read. Such a session is told so rather than being left on a
 * loading line, and the collections behind it are never asked for.
 */
export function holdsNoAccess(
  projectId: string | null | undefined,
  permissions: readonly string[],
): boolean {
  return !projectId && permissions.length === 0;
}
